import { Button } from "@mui/material";
import React from "react";
import { AuthButtonProps } from "../../../interface/types";


const AuthButton: React.FC<AuthButtonProps> = ({message , classes,onClick,disabled}) => {
  return (
    <>
      <div className="w-[100%] !mt-[1.5rem] ">
        <Button
        onClick={onClick}
          className={classes}
          sx={{ borderRadius: 0 }}
          disabled={disabled}
        >
          {message}
        </Button>
      </div>
    </>
  );
};

export default AuthButton;
